import { render, staticRenderFns } from "./CambioEstado.vue?vue&type=template&id=5577580e"
import script from "./CambioEstado.vue?vue&type=script&lang=js"
export * from "./CambioEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports